import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

const TooltipPositioned = (props: any) => {
    return (
        <div>
            <OverlayTrigger
                key={props.placement}
                placement={props.placement}
                overlay={
                    <Tooltip id={`tooltip-${props.placement}`}>
                        <div>{props.item}</div>
                    </Tooltip>
                }
            >
            <div>{props.item}</div>
            </OverlayTrigger>
        </div>
    );
}

export default TooltipPositioned;